import React, { useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { useTranslation } from 'react-i18next';
import { OrgChartHr } from 'routes/HumanResourcesModule/PayState/helpers/types';
import { orgChartHrFormatter } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';
import { Autocomplete, TextField } from '@mui/material';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/components/Modals/helpers/dataHelpers';

type Props = {
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
    orgChartHrs: OrgChartHr[];
    disabled?: boolean;
};

export default function OrgChartHrSelector({
    formState,
    setFormState,
    orgChartHrs,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const existingItem =
        orgChartHrs.find(
            (item) =>
                item.softwareId === formState.selectedOrgChartHrsSoftwareId,
        ) || null;

    const [selectedItem, setSelectedItem] = useState<OrgChartHr | null>(
        existingItem,
    );

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl required fullWidth>
                <Autocomplete
                    options={orgChartHrs}
                    noOptionsText={t('humanResources.simulation.noOptions')}
                    getOptionLabel={(option) =>
                        orgChartHrFormatter({
                            orgChartHrName: option.name,
                            orgChartHrMapping: option.orgChartHrMapping?.title,
                        })
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t(
                                'humanResources.simulation.addAgent.orgChartHr',
                            )}
                            required
                        />
                    )}
                    value={selectedItem}
                    onChange={(_, newValue) => {
                        setSelectedItem(newValue);
                        setFormState({
                            ...formState,
                            selectedOrgChartHrsSoftwareId:
                                newValue?.softwareId ?? '',
                        });
                    }}
                    isOptionEqualToValue={(option, value) =>
                        option.softwareId === value?.softwareId
                    }
                />
            </FormControl>
        </Box>
    );
}
